import { ICommunicationType } from "../../interfaces/Correspondence";

export const optionsCommunicationType: ICommunicationType[] = [
  {
    isParam: true,
    option: "RightToPetitionInterest",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "CitizenComplaints",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "PublicServantComplaints",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "Claims",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "Complaints",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "ApplicationDocumentsOrCopies",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "ApplicationPublicInformation",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "PetitionBetweenAuthorities",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "ConsultationApplication",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "ConceptApplication",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "CopyByCompetition",
    responseTime: 0,
  },
  {
    isParam: true,
    option: "Application",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Congratulations",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "IncidentOfContempt",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "CommunicationsControlEntities",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Guardianship",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Memos",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Memorandum",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "InternalCommunications",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "MobilityProcedures",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "AccountTransfer",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "CollectionAccounts",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Invitation",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Reply",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "TendersProposals",
    responseTime: 0,
  },
  {
    isParam: false,
    option: "Informative",
    responseTime: 0
  },
];
